import React, { useEffect, useState } from "react";
import leftArrow from "../../../assets/Images/left-arrow.png";
import rightArrow from "../../../assets/Images/right-arrow.png";
import Allowcate from "../../../assets/Images/allowcate.png";
import Close from "../../../assets/Images/close.png";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Filter from "../../../assets/Icons/filter.png";
import Download from "../../../assets/Icons/download.png";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import { Ascending, Descending } from "../../../services/_helpers/sorting";
import ExcelExport from "../../../compnenets/commons/xls";

export default function Manpower(props) {
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "manpower resources",
    sheet: "Manpower",
  });
  const [role, setRole] = useState([]);
  const [roleType, setRoleType] = useState([]);
  const getRole = async () => {
    const role = await DPR_API.get_Resource_role();
    if (role && role?.Role.length) {
      setRole(role.Role);
    } else {
      setRole([]);
    }
  };
  const getRoleType = async () => {
    const roleType = await DPR_API.get_Resource_role_type();
    if (roleType && roleType?.Role_type.length) {
      setRoleType(roleType.Role_type);
    } else {
      setRoleType([]);
    }
  };
  useEffect(() => {
    getRole();
    getRoleType();
  }, []);

  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const onCloseModalFilter = () => setOpenFilter(true);
  const onOpenModal = (data) => {
    setResourcesAll(data);
    setOpen(true);
  };
  const onCloseModal = () => setOpen(true);

  const [resources, setResources] = useState([]);
  const [resourcesAll, setResourcesAll] = useState([]);

  const getMapPowerById = async (id) => {
    const manP = await DPR_API.get_resource_manpower(id);
    if (manP && manP.resources?.length) {
      setResources(manP.resources);
    }
  };

  const getMapPowerBySub = async (id) => {
    const manP = await DPR_API.get_resourcebysubId(id);
    if (manP && manP.resources?.length) {
      setResources(manP.resources);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("state");
    const userInfo = JSON.parse(user);
    const wind = window.location.href;
    let sub_id = wind.split("sub_id=")[1];
    if (sub_id) {
      getMapPowerBySub(sub_id);
    } else {
      getMapPowerById(userInfo.user.user_id);
    }
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(resources.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = resources.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const usr = localStorage.getItem("state");
  const state = JSON.parse(usr);
  const [filterData, setFilterData] = useState({
    user_id: state?.user?.user_id,
    startDate: "",
    endDate: "",
    role: "",
    role_type: "",
    Resource_name: "",
    sortOrder: "ASC",
    sortBy: "Role",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilterClick = async () => {
    const manP = await DPR_API.get_filter_resource_manpower(filterData);
    if (manP && manP.resources?.length) {
      setResources(manP.resources);
    }
    setOpenFilter(false);
  };

  return (
    <React.Fragment>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource Manpower Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpenFilter(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Role</label>
                  <select
                    name="role"
                    value={filterData.role}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select role</option>
                    {role?.length
                      ? role.map((val) => (
                          <option key={val.role_id} value={val.role_id}>
                            {val.role_name}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
                <div className="col-6">
                  <label className="filter-label">Role Type</label>
                  <select
                    name="role_type"
                    value={filterData.role_type}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select role type</option>
                    {roleType?.length
                      ? roleType.map((val) => (
                          <option key={val.roleType_id} value={val.roleType_id}>
                            {val.roletype_name}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Resource Name</label>
                  <input
                    type="text"
                    name="Resource_name"
                    value={filterData.Resource_name}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Manpower</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: 20 }}>
          {["Role", "Type", "Created"].map((sortOption) => (
            <div className="form-check" key={sortOption}>
              <input
                className="form-check-input shadow-none"
                type="radio"
                name="sortBy"
                id={sortOption}
                value={sortOption}
                checked={filterData.sortBy === sortOption}
                onChange={handleChange}
              />
              <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                {sortOption}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => handleFilterClick(filterData)}
          >
            Filter
          </button>
        </div>
      </Modal>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource Name</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          {resourcesAll?.map((val) => (
            <div>
              <span
                style={{
                  color: "rgba(0, 128, 198, 1)",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {val}
              </span>
            </div>
          ))}
        </div>
      </Modal>
      <div className="row" style={{ marginRight: 25 }}>
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={resources?.map((val) => {
                return {
                  Role: val?.role,
                  "Role Type": val?.role_type,
                  Resources: val?.Resource_name.join(", "),
                  "Number of Resources": val?.Resource_name.length,
                };
              })}
              fileName="Manpower List"
              sheet="Manpower List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpenFilter(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto">
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
              onClick={() => {
                const user = localStorage.getItem("state");
                const userInfo = JSON.parse(user);
                getMapPowerById(userInfo.user.user_id);
                setCurrentPage(1);
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container" style={{ marginRight: 30 }}>
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No</th>
              <th>Role</th>
              <th>Role Type</th>
              <th>Resource Name</th>
              <th>No of Resources</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row.role}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row.role_type}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row?.Resource_name?.join()}
                  <span
                    className="view-all"
                    onClick={() => onOpenModal(row?.Resource_name)}
                  >
                    View All
                  </span>
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <span className="no-of-resource">{row.no_of_resources}</span>
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, resources.length)} to{" "}
            {Math.min(currentPage * rowsPerPage, resources.length)} of{" "}
            {resources.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow} // Replace with your actual image path
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}
            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow} // Replace with your actual image path
                alt="Next"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
